import React, { Component } from "react";
import "./GridCars.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import { isMobile } from "react-device-detect";
import { fetchAutos } from "../../actions/cars";
import store from "../../store";
import Navbar from "../Navbar/Navbar";

class gridCars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "any",
      models: []
    };
  }

  componentDidMount = () => {
    store.dispatch(fetchAutos()).then(() => this.fillAutos());
  };

  fillAutos = () => {
    console.log("FILL AUTOS" + store.getState().carsReducer.autos);
    this.setState({ models: store.getState().carsReducer.autos });
    if (isMobile) this.setState({ selected: this.state.models[0].modelo });
  };

  handleChange = event => {
    console.log(event.target.id);
    if (this.state.selected == event.target.id) {
      this.setState({ selected: "any" });
    } else {
      this.setState({ selected: event.target.id });
    }
    //this.setProps({ selectedModel: event.target.id });
  };

  handleSelection = model => {
    this.setState({ selected: model });
  };

  render() {
    return (
      <React.Fragment>
        <Navbar
          onClick={this.props.playVideoHander}
          handleSelection={this.handleSelection}
        />

        <Grid container className={isMobile ? "GridCarMobile" : "GridCarWeb"}>
          <Grid item xs={12} sm={12}>
            <div className={isMobile ? "TitleMobile" : "Title"}>
              Elegí tu próximo modelo, ¡0KM, cero vueltas!
            </div>
            <div className="Title-middle">
              Todos los modelos están disponibles, listos para ser patentados.
              ¡Reservá el tuyo ahora!
            </div>
          </Grid>

          <Grid item xs={12} className="ModelButtons">
            {this.state.models.map(model => (
              <div
                id={model.modelo}
                onClick={this.handleChange}
                className={
                  this.state.selected === model.modelo
                    ? "ModelButtonSelected"
                    : "ModelButton"
                }
              >
                {model.modelo}
              </div>
            ))}
          </Grid>

          {this.state.models.map(model =>
            model.modelo === this.state.selected ||
            this.state.selected == "any" ? (
              <CarModel name={model.modelo} />
            ) : null
          )}

          <Grid item xs={12}>
            <div className="CarModelDesc">
              Precios válidos únicamente para realizar una reserva online y de
              contado. Exenta está la posibilidad de financiación y/o permuta.{" "}
              <br />
              Para más información XXXX-XXXX o consultas@prana.com.ar
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default gridCars;
